import { API_URL, AUTH_URL } from '../constants';
import { APIRequest, APIResponse, HTTPClient, RequestType } from '../services/http_client.service';
import { PostCodeType } from '../types/post_code';
import { composeUrlParams } from '../utils/formatters';

const client = new HTTPClient();

class PostCodeController {
    static async getAll(keywords: string, page: number): Promise<APIResponse> {
        const params = composeUrlParams({ keywords, page: page.toString(), limit: '10' });

        const request = new APIRequest({
            type: RequestType.GET,
            fullUrl: `${AUTH_URL}/postal-code?${params}`,
            isAuthenticated: true
        });

        const response = await client.get(request);

        if (!response.success) {
            return new APIResponse({
                success: false,
                statusCode: response.statusCode,
                errorMessage: response.errorMessage
            });
        }

        return response;
    }

    static async create(postCode: PostCodeType): Promise<APIResponse> {
        const request = new APIRequest({
            type: RequestType.POST,
            fullUrl: `${AUTH_URL}/postal-code`,
            isAuthenticated: true,
            body: JSON.stringify(postCode)
        });

        const response = await client.post(request);

        if (!response.success) {
            return new APIResponse({
                success: false,
                statusCode: response.statusCode,
                errorMessage: response.errorMessage
            });
        }

        return response;
    }

    static async update(postCode: PostCodeType): Promise<APIResponse> {
        const request = new APIRequest({
            type: RequestType.PUT,
            fullUrl: `${AUTH_URL}/postal-code/${postCode.id}`,
            isAuthenticated: true,
            body: JSON.stringify(postCode)
        });

        const response = await client.put(request);

        if (!response.success) {
            return new APIResponse({
                success: false,
                statusCode: response.statusCode,
                errorMessage: response.errorMessage
            });
        }

        return response;
    }

    static async find(id: number): Promise<APIResponse> {
        const request = new APIRequest({
            type: RequestType.GET,
            fullUrl: `${AUTH_URL}/postal-code/${id}`,
            isAuthenticated: true
        });

        const response = await client.get(request);

        if (!response.success) {
            return new APIResponse({
                success: false,
                statusCode: response.statusCode,
                errorMessage: response.errorMessage
            });
        }

        return response;
    }

    static async delete(postCodeId: number): Promise<APIResponse> {
        const request = new APIRequest({
            type: RequestType.DELETE,
            fullUrl: `${AUTH_URL}/postal-code/${postCodeId}`,
            isAuthenticated: true
        });

        const response = await client.delete(request);

        if (!response.success) {
            return new APIResponse({
                success: false,
                statusCode: response.statusCode,
                errorMessage: response.errorMessage
            });
        }

        return response;
    }

    static async refreshWeatherData(postCode: number): Promise<APIResponse> {
        const request = new APIRequest({
            type: RequestType.GET,
            fullUrl: `${API_URL}/postal-code/${postCode}?format=json`
        });

        const response = await client.get(request);

        if (!response.success) {
            return new APIResponse({
                success: false,
                statusCode: response.statusCode,
                errorMessage: response.errorMessage
            });
        }

        return response;
    }
}

export default PostCodeController;
